import { FormikError } from '@nv/basic-components'
import { useTranslation } from 'react-i18next'
import ReactPhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import styles from './PhoneInput.module.scss'
import 'react-phone-number-input/style.css'

export const PhoneInput = ({ field, formik, label, isRequired = false, autocomplete }: any) => {
  const { t } = useTranslation()
  const phoneValue = formik.values[field]
  const showError = formik.touched[field] && phoneValue && !isValidPhoneNumber(phoneValue)

  return (
    <div className={styles['container']}>
      <label htmlFor={field} className={styles['label']}>
        {label || t('form.labels.phoneNumber')} {isRequired && <span className={styles['label--required']}>*</span>}
      </label>

      <ReactPhoneInput
        id={field}
        name={field}
        defaultCountry='CA'
        className={styles['input']}
        value={phoneValue}
        onChange={(value) => formik.setFieldValue(field, value)}
        onBlur={() => formik.setFieldTouched(field, true)}
        international // Ensures flag updates based on input
        autoComplete={autocomplete}
      />

      {showError && <span className={styles['error']}>{t('form.validations.invalidPhone')}</span>}

      <FormikError formik={formik} fieldName={field} />
    </div>
  )
}
